import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Content, SectionTitleHeading, SectionWrapper} from "../../styles";
import { BASEURL } from "../../configure";
import Gallery from "../../components/Gallery"
import Topcover from "../../images/1teardown.png"
import Cast from "../../components/Cast";
import Share from "../../components/Share";

const SectionSmallHeading = styled.h3`
  font-family: "Poppins-SemiBold";
  font-size: ${(props) => (props.fs ? props.fs : "25px")};
  /* text-transform: ${(props) => (props.tt ? props.tt : "uppercase")}; */

  color: ${(props) => (props.color ? props.color : "black")};
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: 0;
  line-height: ${(props) => (props.lh ? props.lh : "")};
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};


  @media (max-width: 599px) {
    font-family: "Poppins-Regular";
    line-height: ${(props) => (props.lh ? props.lh : "")};
    max-width: 100%;
    font-size: ${(props) => (props.fs599 ? props.fs599 : "")};
  }
`;
 const P = styled.p`
  text-align: ${(props) => (props.tlj ? props.tlj : "justify !important")};
  WORD-SPACING: -1px;
  line-height: ${(props) => (props.lh ? props.lh : "")};
  font-family: "Poppins-Regular";
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  font-size: ${(props) => (props.fs ? props.fs : "18px")};
  color: ${(props) => (props.color ? props.color : "#0A0A0A")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  text-align: ${(props) => (props.aligmoz ? props.aligmoz : "")};
  text-align-last: ${(props) => (props.tal ? props.tal : "")};
  margin: ${(props) => (props.m ? props.m : "10px 0")};
  padding: ${(props) => (props.padding ? props.padding : "10px 0")};
  
  @media (max-width: 1420px) {
    max-width: ${(props) => (props.maxWidth1420 ? props.maxWidth1420 : "")};
  }
  @media (max-width: 1330px) {
    font-size: ${(props) => (props.fs1330 ? props.fs1330 : "")};
    max-width: ${(props) => (props.maxWidth1200 ? props.maxWidth1200 : "")};
  }
  @media (max-width: 1270px) {
    max-width: ${(props) => (props.maxWidth1250 ? props.maxWidth1250 : "")};
  }
  @media (max-width: 908px) {
    font-size: ${(props) => (props.fs900 ? props.fs900 : "")};
    line-height: ${(props) => (props.lh900 ? props.lh900 : "")};
    max-width: ${(props) => (props.maxWidth908 ? props.maxWidth908 : "")};
  }
  @media (max-width: 800px) {
    font-size: ${(props) => (props.fs800 ? props.fs800 : "")};
    line-height: ${(props) => (props.lh800 ? props.lh800 : "")};
  }
  @media (max-width: 599px) {
  // text-align: unset !important;
    text-align: ${(props) => (props.align599 ? props.align599 : "")};
    font-size: ${(props) => (props.fs599 ? props.fs599 : "15px")};
    line-height: ${(props) => (props.lh599 ? props.lh599 : "")};
    max-width: 100%;
  }
  @media (max-width: 420px) {
    font-size: ${(props) => (props.fs404 ? props.fs404 : "")};
  }
  @media (max-width: 382px) {
    font-size: ${(props) => (props.fs380 ? props.fs380 : "")};
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
`;
const Topimage = styled.div`
  position: relative;
  height: 50vh;
  background-color: #102537;
  background-image: url(${(props) => (props.bg ? props.bg : '')});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;
const Spacediv = styled.div`
 text-align: ${(props) => (props.tlj ? props.tlj : "justify !important")};
  WORD-SPACING: -1px;
  line-height: ${(props) => (props.lh ? props.lh : "")};
  font-family: "Poppins-Regular";
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  font-size: ${(props) => (props.fs ? props.fs : "18px")};
  color: ${(props) => (props.color ? props.color : "#0A0A0A")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  text-align: ${(props) => (props.aligmoz ? props.aligmoz : "")};
  text-align-last: ${(props) => (props.tal ? props.tal : "")};
  margin: ${(props) => (props.m ? props.m : "10px 0")};
  padding: ${(props) => (props.padding ? props.padding : "10px 0")};
`;
const Buttons = styled.a`
  background-color:#ffffff;
  color:black;
  padding: 5px 20px;
  border:1px solid black;
  text-decoration: none;
`;
const BackButton = styled.a`
  color:#ffffff;
  text-decoration: none;
`;
const Index = () => {
  const [ getId, setId ] = useState('');
  const [ getTitle, setTitle ] = useState('');
  const [ getContent, setContent ] = useState('');
  const [ getImage, setImage ] = useState('');
  const [ getAppleLink, setAppleLink ] = useState('#');
  const [ getSpotify, setSpotify ] = useState('#');
  const [ getCast, setCast ] = useState([]);
  const [ getGallery, setGallery ] = useState([]);
  
  let getPrjectDetails = async (valueId) => {
    let projectDetails = await fetch(BASEURL+'project/'+valueId+'?_embed', {
      method: 'GET',
    })
    const data = await projectDetails.json();

    setId(data?.id)
    setTitle(data?.title?.rendered)
    setContent(data?.content?.rendered)
    setImage(data?._embedded?.['wp:featuredmedia'][0]['source_url'])
    setSpotify(()=>{
      if (data?.metadata?.spotify) {
        return data?.metadata?.spotify[0]
      }else{
        return '#'
      }
    })
    setAppleLink(()=>{
      if (data?.metadata?.applemusic) {
        return data?.metadata?.applemusic[0]
      }else{
        return '#'
      }
    })
    setGallery(()=>{
      if(data?.metadata?.gallery_images){
        let splitData = data?.metadata?.gallery_images[0]
        splitData = splitData?.split(',')
        return splitData
      }
    })
    
    // console.log('data: ', data?._embedded?.['wp:term'])
    setCast(()=>{
      if(data?._embedded?.['wp:term']){
        return data?._embedded?.['wp:term'][0]
      }
    })
  }
  useEffect(()=>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pramId = urlParams.get('id')

    getPrjectDetails(pramId);
  },[getTitle, getContent, getImage])
  return (
    <div>
      <SectionWrapper p="0 0">
        <Topimage bg={getImage}>
          <Container maxWidth="xl" style={{textAlign: 'left',paddingLeft: 20, paddingTop: 20}} ><BackButton href="/"> &lt; Back</BackButton></Container>     
          <img src={Topcover} width='100%' style={{position:'absolute',bottom:'0px',left:'0px',height:'151px'}}/>
        </Topimage>
        <Container maxWidth="xl" style={{minHeight: '52vh'}} >
          <Grid container spacing={3} style={{padding:'50px 0'}}>
            <Grid item xs={12} md={12} justifyContent="left">
              <div style={{display: 'flex',justifyContent: 'space-between'}}>
                <SectionTitleHeading color="#0A0A0A" >{getTitle}</SectionTitleHeading>
                <SectionTitleHeading color="#0A0A0A" fs="18px"  style={{display: 'flex', alignItems: 'center'}} >
                  <Share />
                </SectionTitleHeading>
              </div>
            </Grid>
            <Grid item container xs={12} md={6} justifyContent="left">
              <Content dangerouslySetInnerHTML={{__html: `${getContent}`}} m="30px 0"color="#000000"padding="0"/>

              {getAppleLink != '#' || getSpotify != '#' ?
                <Grid item xs={12} style={{padding:'20px 0 50px'}}>
                  <SectionSmallHeading  fs="18px">Listen on:</SectionSmallHeading>
                  <Spacediv>
                    {getSpotify != '#' ?
                      <Buttons href={`${getSpotify}`} style={{marginRight:'20px'}}>Spotify</Buttons>
                    : null }
                    {getAppleLink != '#' ?
                      <Buttons href={`${getAppleLink}`}>Apple Podcasts</Buttons>
                    : null }
                  </Spacediv>
                </Grid>
              : null }
              {getCast?
                <Grid item xs={12} container spacing={3} style={{padding:'20px 0 50px'}}>
                  <Grid item xs={12} justifyContent="left">
                    <SectionSmallHeading fs="18px" p="0">Cast:</SectionSmallHeading>
                  </Grid>
                  <Cast cast={getCast} />
                </Grid>
                :
                null
              }
            </Grid>
            {getGallery? 
              <Grid item xs={12} md={10} >
                <SectionSmallHeading fs="18px" p="0 0 20px 0">Screenshots:</SectionSmallHeading>
                <Gallery gallery={getGallery} />
              </Grid>
            : null }
          </Grid>
          <P tal="center" padding="10px  0 40px 0" m='0' fs599="14px" align="center">
            Copyright © 2023 Primary Source Media
          </P>
        </Container>
      </SectionWrapper>
      
    </div>
  );
};

export default Index;
